export default __webpack_public_path__ + "static/media/help.f3e072cc.svg";